import { useCallback, useState } from "react"

export function useCountdown() {
  const [timeRemaining, setTimeRemaining] = useState(15)

  const startCountdown = useCallback(() => {
    setTimeRemaining(15)
    const timerInterval = setInterval(() => {
      setTimeRemaining((prevTime) => {
        if (prevTime === 0) {
          clearInterval(timerInterval)
          return 0
        } else {
          return prevTime - 1
        }
      })
    }, 1000)

    return () => clearInterval(timerInterval)
  }, [])

  return { startCountdown, timeRemaining }
}
